import {Component, OnInit} from '@angular/core';
import {ReportService} from '../../../services/report.service';

@Component({
  selector: 'app-price-elasticity',
  templateUrl: './size-elasticity.component.html',
  styleUrls: ['./size-elasticity.component.scss']
})
export class SizeElasticityComponent implements OnInit {

  constructor(private reportService: ReportService) {
  }

  ngOnInit(): void {
    this.reportService.activeReportSubject.next('size-elasticity');
  }

}
